import { Pipe, PipeTransform } from '@angular/core';
import DateHelper from 'src/app/helpers/date-helper';

@Pipe({
  name: 'printASAPDateFormat'
})
export class PrintASAPDateFormat implements PipeTransform {
  transform(value: Date, asap: boolean, format = 'dd/MM/YYYY') {
    if (value == null) {
      return asap ? 'ASAP' : '-';
    } else {
      return DateHelper.formatDate(value, format);
    }
  }
}
